import Vue from 'vue';
import EmployerCareersPage from '../components/ats/careers-page/employer-careers-page.vue';

const vueInstance = new Vue({
  components: { EmployerCareersPage },
});

vueInstance.$mount('.employer-careers-page');
